"use client";

import { useTable } from "spacetimedb/react";
import { tables } from "@/module_bindings";

/** The database view authorizes staff and returns no rows for other users. */
export function useStaffTaxApplications() {
  const [applications, isReady] = useTable(tables.staff_tax_applications);
  return {
    applications,
    isReady,
    attentionCount: applications.filter(
      (application) => application.needsAttention,
    ).length,
  };
}
